import { ElementRef } from '@angular/core';

export class SliderBase {
  public constructor(public _elementRef: ElementRef) {}
}
